import type { App } from 'vue'
import VueScrollPicker from 'vue-scroll-picker'
export default function useVueScrollPicker(app: App) {
  app.use(VueScrollPicker)
}
